import { Reveal } from "@/components/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "Is JomKonvoi free?",
    a: "Yes — the core convoy features are free. Premium is an optional subscription (billed through Stripe) that unlocks extra features like Priority SOS and trip exports. New Premium subscribers get a one-day free trial, and you can cancel before it ends without being charged.",
  },
  {
    q: "How do I start a convoy?",
    a: "Create a convoy in the app and share its 6-character code or QR code with your crew. Drivers, riders, and passengers can all join. The convoy leader sets the destination and route, and can add co-leaders or remove members.",
  },
  {
    q: "Who can see my location?",
    a: "Only members of your convoy, and only while you're in it. Your live position is shared every few seconds during an active convoy and stops the moment you leave. Background location sharing is optional and can be turned off in your device settings at any time.",
  },
  {
    q: "Does the SOS button call emergency services?",
    a: "No. SOS alerts the members of your convoy — it is a coordination signal, not an emergency service. In a real emergency, dial 999 in Malaysia (or your local emergency number) first, then use SOS so your convoy can find you.",
  },
  {
    q: "Does JomKonvoi work for both cars and motorcycles?",
    a: "Yes. A single convoy can mix cars and bikes — everyone appears on the same live map with their own vehicle icon. Set everything up before you move, and never interact with your phone while riding or driving.",
  },
  {
    q: "Do you sell my data?",
    a: "Never. We don't sell personal data or run advertising. Location and chat data exist only to run your convoy, and you can delete trips or your entire account at any time from the Profile screen. Full details are in our Privacy Policy.",
  },
];

export const Faq = () => (
  <section id="faq" className="relative mx-auto max-w-3xl px-6 py-24 sm:py-32" data-testid="faq-section">
    <Reveal>
      <p className="label-tech text-[#00F0FF]">FAQ</p>
      <h2 className="mt-4 font-display text-4xl font-black tracking-tighter text-white sm:text-5xl">
        Questions, answered.
      </h2>
    </Reveal>
    <Reveal delay={0.1} className="mt-12">
      <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
        {faqs.map((f, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="rounded-2xl border border-white/10 bg-white/[0.03] px-6 transition-colors duration-300 data-[state=open]:border-[#FF3333]/30"
            data-testid={`faq-item-${i}`}
          >
            <AccordionTrigger
              className="py-5 text-left font-display text-base font-bold text-white hover:no-underline sm:text-lg"
              data-testid={`faq-trigger-${i}`}
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-5 text-sm leading-relaxed text-neutral-400 sm:text-base" data-testid={`faq-content-${i}`}>
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
